import { render, staticRenderFns } from "./CarrierLogo.vue?vue&type=template&id=521887e2&scoped=true&"
import script from "./CarrierLogo.vue?vue&type=script&lang=js&"
export * from "./CarrierLogo.vue?vue&type=script&lang=js&"
import style0 from "./CarrierLogo.vue?vue&type=style&index=0&id=521887e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521887e2",
  null
  
)

export default component.exports